import {
  SHIJUAN_COLUMN_TYPE_GET,
  SHIJUAN_COLUMN_TYPE_SET,
  SHIJUAN_COLUMN_TYPE_DEAL,
  SHIJUAN_TYPE_MAP_GET,
  SHIJUAN_TYPE_MAP_SET
} from '../resource/shijuan';
import axios from '../config/axios.config';
export default {
  /**
   * @description: 获取栏目下的试卷类型
   * @param {*} columnId
   * @return {*}
   */
  async shijuan_column_type_get(columnId) {
    return await axios.save(SHIJUAN_COLUMN_TYPE_GET, {}, {columnId});
  },
  /**
   * @description: 栏目下管理类型
   * @param {*} columnId
   * @param {*} typeId
   * @return {*}
   */
  async shijuan_column_type_set(typeId, columnId) {
    return await axios.save(SHIJUAN_COLUMN_TYPE_SET, {}, {
      columnId,
      detailTypeId: typeId
    });
  },
  /**
   * @description: 栏目下类型的启用禁用
   * @param {*} id
   * @param {*} used
   * @return {*}
   */
  async shijuan_column_type_deal(id, used) {
    return await axios.update(SHIJUAN_COLUMN_TYPE_DEAL, {
      id,
      used
    }, {});
  },
  async shijuan_get_type_map(params) {
    return await axios.save(SHIJUAN_TYPE_MAP_GET, {}, params);
  },
  async shijuan_set_type_map(params) {
    return await axios.save(SHIJUAN_TYPE_MAP_SET, {}, params);
  }
}



// WEBPACK FOOTER //
// ./src/service/shijuanService.js